import {FC, ReactElement, useState} from 'react'

import {ModalHeaderTitle} from '@components/ui/modal-atoms'
import {Sheet, SheetContent, SheetTrigger} from '@components/ui/sheet'
import {CountriesSelect} from '@features/settings/components/countries-select'
import {SelectedCountry} from '@features/settings/components/add-areas-modal'
import {useTranslation} from '@/translations/i18n'

interface SelectCountriesMobileModalProps {
    selectedCountry: SelectedCountry
    onChangeCountry: (value: SelectedCountry) => void
    region: string | null
    children: ReactElement
}

export const SelectCountriesMobileModal: FC<SelectCountriesMobileModalProps> = ({
    selectedCountry,
    onChangeCountry,
    region,
    children
}) => {
    const {t} = useTranslation()
    const [isOpen, setIsOpen] = useState(false)
    const handleCloseModal = () => setIsOpen(false)

    return (
        <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger render={children} nativeButton={false} />
            <SheetContent
                forceRenderOverlay={true}
                className="grid h-[calc(100%-(--spacing(40)))] grid-rows-[auto_minmax(0,1fr)_auto]"
            >
                <ModalHeaderTitle>{t('settings:areas:country_region_label')}</ModalHeaderTitle>
                <CountriesSelect
                    region={region}
                    onChangeCountry={onChangeCountry}
                    selectedCountry={selectedCountry}
                    isMobile={true}
                    onCloseCountryMobileContent={handleCloseModal}
                />
            </SheetContent>
        </Sheet>
    )
}
